// extracted by mini-css-extract-plugin
export default {"title":"HighlightsSlider_title__4qb-C","footer":"HighlightsSlider_footer__Vzpv-","arrows":"HighlightsSlider_arrows__m1PiO","tryButton":"HighlightsSlider_tryButton__7WTwl"};